import { getField, updateField } from 'vuex-map-fields';
import { client } from "@/api/client";
import { jobs } from '../../api/jobs.js';
import axios from "axios";

export const SET_KPIS_DATA = "SET_KPIS_DATA";
export const SET_ASYNC_JOB_ID = "SET_ASYNC_JOB_ID";
export const SET_DOWNLOAD_JOB_STATE = "SET_DOWNLOAD_JOB_STATE";
export const SET_KPI_DOC_DATA_ORDERING = "SET_KPI_DOC_DATA_ORDERING";
export const SET_TABLE_ASYNC_JOB_ID = "SET_TABLE_ASYNC_JOB_ID";
export const SET_TABLE_JOB_STATE = "SET_TABLE_JOB_STATE";

export const NEXT_KPI_DOC_ORDER = "NEXT_KPI_DOC_ORDER";
export const SET_KPI_DOC_ORDER = "SET_KPI_DOC_ORDER";
export const SET_KPI_DOC_DATE_TO_ORDER = "SET_KPI_DOC_DATE_TO_ORDER";
export const REORDER_KPI_DOC_DATA_ORDERING = "REORDER_KPI_DOC_DATA_ORDERING";
export const SET_KPI_WRITTEN_DATE = "SET_KPI_WRITTEN_DATE";
export const SET_KPI_ID = "SET_KPI_ID";

const state = () => ({
    kpi: {text: 'Documentos', value:'get_kpis_document_data', row_header:'Usuario', excel:'download_excel_kpis_document_data', aj: true},
    kpi_items: [
        // {text: 'Total de documentos', value:'get_kpis_data', row_header:'Usuario', excel:'download_excel_kpis_data'},
        // {text: 'Porcentaje de documentos procesados correctamente', value:'get_kpis_processed_correctly_percent', row_header:'Usuario', excel:'download_excel_kpis_processed_correctly_percent'},
        {text: 'Documentos', value:'get_kpis_document_data', row_header:'Usuario', excel:'download_excel_kpis_document_data', aj: true},
        {text: 'Desglose Errores', value:'get_kpis_doc_errors', aj: false},
        {text: 'Leads', value:'get_kpis_leads_data', row_header:'Estado', excel:'download_excel_kpis_leads_data', aj: true},
        {text: 'Estado de cada training simulado en cada red neuronal', value: 'get_kpis_simulations_data', aj: true},
        {text: 'Nº de simulación en por estado en cada red neuronal', value: 'get_kpis_simulation_states_count_data', aj: true},
        {text: 'Porcentaje de usuarios por cada tipo de Conector', value: 'get_kpis_percent_cdbtype', aj: false},
        {text: 'Usuarios que llevan mucho sin subir un documento', value: 'get_kpis_user_without_recent_login', aj: false},
    ],
    kpis_data: {},
    trimester: '',
    trimester_items: [
        {text: 'Q1', value:'-01-01'},
        {text: 'Q2', value:'-04-01'},
        {text: 'Q3', value:'-07-01'},
        {text: 'Q4', value:'-10-01'},
    ],
    year: '',
    year_items: ['2020', '2021', '2022', '2023'],

    downloadJobState: 'done',
    asyncJobId: 0,

    tableJobState: 'done',
    tableAsyncJobId: 0,

    kpi_doc_order: '',
    kpi_doc_date_to_order: '',
    kpi_doc_order_symbols: {
        'ASC': '▲',
        'DESC': '▼',
        '': '',
    },
    kpi_doc_data_ordering: [],

    docs_values: [
        {text: 'Documentos', value:'text'},
        {text: 'Entrenamiento', value:'training'},
    ],
    show_doc: 'text',
    kpi_written_date: '',
    company: {},
    kpi_filters: {
        'docs': {
            'show_trials': true,
            'show_staff': false,
            'show_unactive': false,
        },
        'leads': {},
        'simulations_data': {},
        'simulation_states': {},
    },

    kpi_id: 0,
    date_ini: '',
    date_end: '',
});

const getters = {
    getField,
}

const mutations = {
    updateField,
    [SET_KPIS_DATA](state, kpis_data) {
        state.kpis_data = kpis_data;
    },
    [SET_ASYNC_JOB_ID](state, asyncJobId) {
        state.asyncJobId = asyncJobId;
    },
    [SET_DOWNLOAD_JOB_STATE](state, downloadJobState) {
        state.downloadJobState = downloadJobState;
    },
    [SET_TABLE_ASYNC_JOB_ID](state, tableAsyncJobId) {
        state.tableAsyncJobId = tableAsyncJobId;
    },
    [SET_TABLE_JOB_STATE](state, tableJobState) {
        state.tableJobState = tableJobState;
    },
    [SET_KPI_DOC_DATA_ORDERING](state, order_data) {
        state.kpi_doc_data_ordering = order_data;
    },

    [NEXT_KPI_DOC_ORDER](state) {
        if (state.kpi_doc_order == '') {
            state.kpi_doc_order = 'DESC';
        } else if (state.kpi_doc_order == 'DESC') {
            state.kpi_doc_order = 'ASC';
        } else if (state.kpi_doc_order == 'ASC') {
            state.kpi_doc_order = '';
        } 
    },
    [SET_KPI_DOC_ORDER](state, order) {
        state.kpi_doc_order = order;
    },
    [SET_KPI_DOC_DATE_TO_ORDER](state, week) {
        state.kpi_doc_date_to_order = week;
    },
    [REORDER_KPI_DOC_DATA_ORDERING](state) {
        state.kpi_doc_data_ordering.sort(function(a,b) {
            let user_a = Object.keys(a)[0]
            let user_b = Object.keys(b)[0]
            if (user_a != 'Total' && user_b != 'Total') {
                if (state.kpi_doc_order == 'ASC') {
                    return a[user_a]['% de carga'][state.kpi_doc_date_to_order][state.show_doc] - b[user_b]['% de carga'][state.kpi_doc_date_to_order][state.show_doc];
                } else if (state.kpi_doc_order == 'DESC') {
                    return b[user_b]['% de carga'][state.kpi_doc_date_to_order][state.show_doc] - a[user_a]['% de carga'][state.kpi_doc_date_to_order][state.show_doc];
                } else {
                    if (user_a < user_b) {
                        return -1;
                    } else if (user_a > user_b) {
                        return 1;
                    }
                }
            } 
            return 0;
        });
    },
    [SET_KPI_WRITTEN_DATE](state, kpi_written_date) {
        state.kpi_written_date = kpi_written_date;
    },
    [SET_KPI_ID](state, kpi_id) {
        state.kpi_id = kpi_id;
    },
}

const getKpis = ({ commit, state, dispatch }) => {
    return new Promise((resolve, reject)=> {
        let filters = '';
        if (['get_kpis_document_data', 'get_kpis_leads_data'].includes(state.kpi.value) && state.trimester && state.year) {
            filters = '?date=' + state.year + state.trimester;
        } else if (['get_kpis_simulations_data', 'get_kpis_simulation_states_count_data'].includes(state.kpi.value) && state.company && state.company) {
            filters = '?companydb_id=' + state.company.id;
        } else if (['get_kpis_percent_cdbtype'].includes(state.kpi.value) && state.date_ini && state.date_end) {
            filters = '?date_ini=' + state.date_ini + '&date_end=' + state.date_end;
        } else if (['get_kpis_user_without_recent_login'].includes(state.kpi.value) && state.date_ini) {
            filters = '?date=' + state.date_ini
        }
        commit(SET_KPI_DOC_ORDER, '');
        commit(SET_KPI_DOC_DATE_TO_ORDER, '');
        client.get(state.kpi['value'] + '/' + filters).then(response => {
            if (state.kpi['aj']){
                commit(SET_TABLE_ASYNC_JOB_ID, response['data']['AsyncJob']);
                commit(SET_TABLE_JOB_STATE, "running");
            } else {
                commit(SET_KPIS_DATA, response.data);
            }
            resolve();
        }).catch(err=>{
            console.error(err)
            reject();
        });
    });
}

const downloadExcel = ({ commit, state }) => {
    return new Promise((resolve, reject)=> {
        client.get(state.kpi['excel'] + '/').then(response => {
            commit(SET_ASYNC_JOB_ID, response['data']['AsyncJob']);
            commit(SET_DOWNLOAD_JOB_STATE, "running");
            resolve();
        }).catch(err=>{
            console.log(err)
            reject();
        });
    });
}

const orderDocKpi = ({ commit }, week) => {
    commit(NEXT_KPI_DOC_ORDER);
    commit(SET_KPI_DOC_DATE_TO_ORDER, week);
    commit(REORDER_KPI_DOC_DATA_ORDERING);
}

const tableJobDone = async ({ commit, state, dispatch }) => {
    const response = await jobs.getJob({ id: state.tableAsyncJobId });
    let url = response['data']['output_info']['data']
    commit(SET_KPI_ID, response['data']['output_info']['kpi']);
    commit(SET_KPI_WRITTEN_DATE, response['data']['output_info']['written']);
    commit(SET_KPIS_DATA, {});
    axios({
        method:'get',
        url: url,
        responseType: 'arraybuffer'
    }).then(resp => {
        let decodedString = new TextDecoder().decode(new Uint8Array(resp.data));
        let data = JSON.parse(decodedString);
        commit(SET_KPIS_DATA, data);
        if (state.kpi['text'] == 'Documentos') {
            let data_order = [];
            for (let user in data) {
                let item = {};
                item[user] = { '% de carga': {} };
                for (let week in data[user]['% de carga']) {
                    item[user]['% de carga'][week] = {};
                    item[user]['% de carga'][week]['text'] = parseFloat(data[user]['% de carga'][week]['text'].substring(0, data[user]['% de carga'][week]['text'].length - 2));
                    try {
                        item[user]['% de carga'][week]['training'] = parseFloat(data[user]['% de carga'][week]['training'].substring(0, data[user]['% de carga'][week]['training'].length - 2));
                    } catch {
                        item[user]['% de carga'][week]['training'] = 0;
                    }
                }
                if (user != 'Total') {
                    item[user]['is_staff'] = data[user]['is_staff']
                    item[user]['is_trial'] = data[user]['is_trial']
                    item[user]['is_active'] = data[user]['is_active']
                }
                
                data_order.push(item);
            }
            commit(SET_KPI_DOC_DATA_ORDERING, data_order);
            if (Object.keys(data['Total']['Cargados']).includes('Trimestre')) {
                dispatch("orderDocKpi", "Trimestre");
            }
        }
        // resolve();
    }).catch(err => {
        console.debug(err)
        // reject();
    });
}

const getHistogram = async ({}, url) => {
    return new Promise((resolve, reject)=> {
        client.get(url).then(response => {
            resolve(response.data);
        })
        // .catch(err => {
        //     console.debug(err)
        //     reject();
        // });
    });
}

const deleteSimulations = ({}, params) => {
    return new Promise((resolve, reject) => {
        client.post('delete_simulations/', params).then(resp => {
            resolve(resp);
        }).catch(err => {
            reject(err);
        });
    });
}

const actions = {
    getKpis,
    downloadExcel,
    orderDocKpi,
    tableJobDone,
    getHistogram,
    deleteSimulations,
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}